import BaseModule from './BaseModule';
import Factory from '../libs/Factory';
import {requireElement} from "../libs/Helpers";

export default class HorizontalScroll extends BaseModule {
    private readonly track: HTMLElement;
    private readonly pinSection: HTMLElement;
    private slides: HTMLElement[];

    constructor(el: HTMLDivElement, factory: Factory) {
        super(el, factory, 'HorizontalScroll');

        this.pinSection = el; // requireElement(el, ".horizontal-pin-section");
        this.track = requireElement(el, ".horizontal-scroll-track");

        const getScrollAmount = () => {
            let trackWidth = this.track.scrollWidth;
            return -(trackWidth - window.innerWidth);
        }

        Promise.all([
            import(/* webpackChunkName: "gsap" */ 'gsap'),
            import(/* webpackChunkName: "gsap" */ 'gsap/ScrollTrigger'),
        ]).then(([gsapModule, ScrollTriggerModule]) => {
            const gsap = gsapModule.gsap;
            this.slides = gsap.utils.toArray<HTMLElement>(".horizontal-slide");

            if (this.track && this.pinSection && this.slides.length > 0) {
                // change loading as side scroll makes them load in...
                this.track.querySelectorAll('img').forEach((img) => {
                    img.setAttribute('loading', 'eager');
                });

                gsap.registerPlugin(ScrollTriggerModule.ScrollTrigger);

                const keyframes = [
                    { autoAlpha: 0, duration: 0 },
                    { autoAlpha: 1, duration: 0.3 },
                    { autoAlpha: 1, duration: 0.4 },
                    { autoAlpha: 0, duration: 0.2 },
                    { autoAlpha: 0, duration: 0.1 },
                ];
                const scrollTriggerBase = {
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                };

                gsap.matchMedia().add("(min-width: 768px)", () => {
                    const scrollTween = gsap.to(this.track, {
                        x: getScrollAmount,
                        ease: "none",
                        scrollTrigger: {
                            trigger: this.pinSection,
                            pin: true,
                            scrub: true,
                            // Dynamic End: The longer the content, the longer the scroll lasts
                            // We use a multiplier (e.g., based on width) to control scroll speed
                            end: () => "+=" + Math.abs(getScrollAmount()),
                            invalidateOnRefresh: true, // Crucial: Recalculates everything if user resizes browser
                            // anticipatePin: 1,
                            // markers: true,
                        }
                    });

                    gsap.utils.toArray<HTMLElement>(".parallax-img, .parallax-txt").forEach((img) => {
                        // Randomize speed slightly for a more organic feel, or fix it
                        const speed = img.getAttribute('data-speed') || 150;
                        gsap.to(img, {
                            x: -speed,
                            ease: "none",
                            scrollTrigger: {
                                ...scrollTriggerBase,
                                trigger: img,
                                containerAnimation: scrollTween, // Links to the main scroll
                            },
                            // keyframes,
                        });
                    });
                }).add("(max-width: 767px)", () => {
                    gsap.utils.toArray<HTMLElement>(".parallax-img:not(.elementor-widget-text-editor)").forEach((img) => {
                        const speed = 150;
                        gsap.to(img, {
                            y: -speed,
                            ease: "none",
                            scrollTrigger: {
                                ...scrollTriggerBase,
                                trigger: img,
                            },
                            // keyframes,
                        });
                    });
                });
            }
        });
    }
}